import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No, el protocolo se basa en hábitos fisiológicos naturales.'
}, {
  q: '¿Funciona si tengo mucha ansiedad?',
  a: 'Sí, la técnica respiratoria está diseñada específicamente para colapsar el sistema de alerta.'
}, {
  q: '¿Qué pasa si mi pareja ronca?',
  a: 'Incluimos una sección sobre el entorno que te ayudará a manejar ruidos externos.'
}, {
  q: '¿Es difícil de seguir?',
  a: 'No, son cambios pequeños que toman menos de 5 minutos cada uno.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-navy-800" data-id="element-132">
      <div className="max-w-3xl mx-auto px-6" data-id="element-133">
        <FadeIn data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-12" data-id="element-135">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-136">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-137">
              <div className="border border-navy-600 rounded-sm overflow-hidden bg-navy-900" data-id="element-138">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-139">
                  <span className="text-lg font-medium text-cream pr-4" data-id="element-140">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-141" />
                </button>
                <AnimatePresence data-id="element-142">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-143">
                      <div className="px-6 pb-5 text-cream-muted" data-id="element-144">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}